import React, { Component } from 'react';

import Core from './../../Core/Core';

class ReworkItem extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            "entry" : {},
            "clients" : []
        }

        this.handleSelect = this.handleSelect.bind(this);
    }


    handleSelect(evt)
    {
        this.props.onChange({
            "target" : {
                "name" : this.props.index,
                "value" : evt.target.value
            }
        });
    }

    render()
    {
        return (
            
            <div className="card m-4">
                <div className="card-header h3">
                    Conflit #{ this.props.conflict.id }
                    <span className="btn btn-primary float-right">
                        Conflits <span className="badge badge-light">{ this.props.conflict.clients.split(";").length }</span>
                    </span>
                </div>
                <div className="card-body">
                    <h5 className="card-title">Résolution de conflit</h5>
                    <div className="row">
                        <div className="col">
                            <p className="card-text">Sélectionnez un client auquel associer cet élément</p>
                            <select onChange={ this.handleSelect } value={ this.props.conflict.entry.Client_id != null ? this.props.conflict.client : this.props.conflict.client }>    
                                <option value="">- Ignorer -</option>
                                { 
                                    this.props.conflict.clientslist.map((e) => {
                                        if(e == null)
                                            return;
                                        return (
                                            <option key={e.id} value={ e.id }>#{e.id} { e.name } - { e.email } ({ e.company })</option>
                                        )
                                    })
                                }
                            </select>
                        </div>
                        <div className="col">
                            <p className="card-text">En cas de doute, vous pouvez consulter les fiches ci-dessous.</p>
                            <ul>
                                { 
                                    this.props.conflict.clientslist.map((e) => {
                                        if(e == null)
                                            return;
                                        return (
                                            <li key={ e.id }><a target="_blank" href={ "/client/"+e.id } >#{e.id} { e.name } - { e.email } ({ e.company })</a></li>
                                        )
                                    })
                                }
                            </ul>
                            <p>
                                Si les entrées vous sembles être identiques, vous pouvez les fusionner depuis le menu de recherche.
                            </p>
                        </div>
                    </div>
                </div>
                <ul className="list-group list-group-flush">
                    {
                        this.props.conflict.name1 != null &&
                        <li className="list-group-item">
                            <label className="badge badge-secondary"><h5>Intitulé 1</h5></label> 
                            <span> </span>{ this.props.conflict.name1 }
                        </li>
                    }
                    {
                        this.props.conflict.name2 != null &&
                        <li className="list-group-item">
                            <label className="badge badge-secondary"><h5>Intitulé 2</h5></label> 
                            <span> </span>{ this.props.conflict.name2 }
                        </li>
                    }
                    <li className="list-group-item">
                        <label className="badge badge-secondary"><h5>Type</h5></label> 
                        <span> </span>{ this.props.conflict.Table_name }
                    </li>
                    {
                        this.props.conflict.entry.name != null &&
                        <li className="list-group-item">
                            <label className="badge badge-secondary"><h5>Intitulé</h5></label> 
                            <span> </span>{ this.props.conflict.entry.name }
                        </li> 
                    }
                    {
                        this.props.conflict.entry.code != null &&
                        <li className="list-group-item">
                            <label className="badge badge-secondary"><h5>Immatriculation</h5></label> 
                            <span> </span>{ this.props.conflict.entry.code }
                        </li> 
                    }
                    {
                        this.props.conflict.entry.type != null &&
                        <li className="list-group-item">
                            <label className="badge badge-secondary"><h5>Type d'intérêt</h5></label> 
                            <span> </span>{ this.props.conflict.entry.type }
                        </li> 
                    }
                </ul>
            </div>
        );
    }
}

export default ReworkItem;


// WEBPACK FOOTER //
// ./src/Components/Rework/ReworkItem.js